import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import InputGroup from 'react-bootstrap/InputGroup';
import Button from 'react-bootstrap/Button';
import LivingPlaceAutocomplete from '../../common/LivingPlaceAutocomplete.jsx';


function LivingPlaceForm(props) {
  const { anyTouched, handleSubmit } = props;

  return <form onSubmit={ handleSubmit } className={ anyTouched ? 'was-validate' : '' }>
    <InputGroup>
      <LivingPlaceAutocomplete label={ gettext('Место жительства') }
                               placeholder={ gettext('Место жительства') }
                               autoFocus={ true }
                               simple={ true }/>
      <InputGroup.Append>
        <Button variant='primary' type='submit' title={ gettext('Сохранить') }>
          <i className='icon icon-ok-circled2'></i>
        </Button>
        <Button variant='secondary' title={ gettext('Отменить') } onClick={ props.onCancel }>
          <i className='icon icon-cancel-circled2'></i>
        </Button>
      </InputGroup.Append>
    </InputGroup>
  </form>
}

export default compose(
  connect(state => ({ initialValues: { living_place: state.user.living_place }})),
  reduxForm({form: 'livingPlaceForm'})
)(LivingPlaceForm)
